import { init } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"
import { unbindOriginalSearch, renderSearchBar } from "./helpers"

import "./styles/index.css"

// unbindOriginalSearch("#shopify-section-header > div > header > nav > main-header > div > div > div > div.flex-1.flex.items-center.justify-end > div > search-icon")

const inputSelector = renderSearchBar();

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    categoryComponent: Category,
    historyEnabled: true,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    // inputCssSelector: '#boost-pfs-search-box-0[type="search"]',
    inputCssSelector: inputSelector,
    contentCssSelector: '#MainContent',
    serpUrlMapping: {
        query: "q",
    },
    // Uncomment to redirect to search page instead of rendering on the same page
    serpPath: '/search',

    // Uncomment to redirect to search page instead of rewriting browser history
    // serpPathRedirect: true,
    serpQuery: {
        products: {
            // fields: [
            //     "productId", "name",
            //     "url", "brand",
            //     "imageUrl", "alternateImageUrls",
            //     "availability",
            //     "price", "listPrice",
            //     "tags1", "skus.name",
            //     "customFields.key", "customFields.value"
            // ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0,
        },
    },
    autocompleteQuery: {
        products: {
            // fields: [
            //     "productId", "name",
            //     "url", "brand",
            //     "imageUrl", "alternateImageUrls",
            //     "availability",
            //     "price", "listPrice",
            //     "tags1", "skus.name",
            //     "customFields.key", "customFields.value"
            // ],
            size: defaultConfig.autocompleteProductsSize,
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"],
        },
    },
    compressUrlParameters: true,
    // // Uncomment for Category Merchandising
    categoryCssSelector: '#nosto-category-merchandising',
    categoryQuery() {
        return {
            name: 'serp',
            products: {
                categoryId: this.categoryId(),
                categoryPath: this.categoryPath(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
    /* old method: */
    // categoryQuery() {
    //     if(document.querySelector('.nosto_page_type')?.textContent !== 'category' || !document.querySelector('.nosto_category')) return;
    //     return {
    //         name: 'serp',
    //         products: {
    //             categoryPath: document.querySelector('.nosto_category > .category_string')?.textContent,
    //             categoryId: document.querySelector('.nosto_category > .id')?.textContent,
    //             size: defaultConfig.serpSize,
    //             from: 0,
    //         }
    //     }
    // },
}).then(() => {
    const searchInputEls = document.querySelectorAll('.search__input[type="search"]');
    searchInputEls.forEach(inputEl => {
        inputEl.addEventListener('keydown', (e) => {
            if(e.key === 'Enter' || e.keyCode === 13) {
                document.querySelector('.search__button--close').click();
            }
        })
    })
})
